/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { O5AwsDeployerV1DeploymentState } from '@interxfi/types';
import { schema } from 'normalizr';

export const O5_AWS_DEPLOYER_V1_DEPLOYMENT_STATE_ENTITY_NAME = 'o5.aws.deployer.v1.Deployment';
export const o5AwsDeployerV1DeploymentStateEntity = new schema.Entity<O5AwsDeployerV1DeploymentState>(O5_AWS_DEPLOYER_V1_DEPLOYMENT_STATE_ENTITY_NAME, {}, { idAttribute: 'deploymentId' });

